//所有数据中心获取广告位置接口
import request from '@/utils/request';
export function getadvLocation(data) {
  return request({
    url: '/adv/search_advplace',
    method: 'get',
    params: data
  });
}